<template>
  <div class="message-success-modal__container" v-if="visible">
    <div class="message-success-modal__box">
      <div class="message-success-modal__head">
        <h3 class="message-success-modal__title">
          {{ messageSuccessModal.title }}
        </h3>
      </div>
      <div class="message-success-modal__body">
        <div class="message-success-modal__des1" v-html="$convertPxToRem(messageSuccessModal.desc1)"></div>
        <div class="message-success-modal__card" v-html="$convertPxToRem(messageSuccessModal.desc2.replace('$m_no', this.dataInfo && this.dataInfo.m_no ? this.dataInfo.m_no : ''))"></div>
      </div>
      <div class="message-success-modal__foot">
        <div
          class="message-success-modal__foot-btn message-success-modal__foot-btn-close"
          @click="close"
        >
          {{ messageSuccessModal.closeBtn }}
        </div>
        <el-button
          type="text"
          class="message-success-modal__foot-btn message-success-modal__foot-btn-confirm"
          @click="goMessageDetails"
        >
          <span>{{ messageSuccessModal.confirmBtn }}</span>
        </el-button>
      </div>
    </div>
    <div class="mask"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MessageSuccessModal",

  data() {
    return {
      visible: false,
      dataInfo: {},
    };
  },

  computed: {
    ...mapGetters(["currentLang"]),
    messageSuccessModal() {
      return this.currentLang.config.contactUs.messageSuccessModal;
    },
  },

  created() {},

  methods: {
    open(info) {
      this.dataInfo = info ? info : {}
      this.visible = true;
    },

    close() {
      this.visible = false;
    },

    goMessageDetails() {
      this.$router.push(`/message-record?isEmail=0&m_no=${this.dataInfo && this.dataInfo.m_no ? this.dataInfo.m_no : ''}`)
    }
  },
};
</script>

<style lang="scss" scoped>
.message-success-modal__container {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
}

.mask {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 150;
  background-color: rgba(0, 0, 0, 0.6);
  font-size: var(--text-size-normal);
}

.message-success-modal__box {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 200;
  transform: translate(-50%, -50%);
  width: 750px;
  padding: 40px 40px;
  background-color: #fff;
  border-radius: 15px;

  .message-success-modal__head {
    .message-success-modal__title {
      margin-bottom: 18px;
      text-align: center;
      font-size: 26px;
      font-weight: 500;
      letter-spacing: 2px;
    }
  }

  .message-success-modal__body {
    margin: 40px 0 80px;
    font-size: 18px;
    line-height: 1.8;
    text-align: justify;

    .message-success-modal__des1 {
      text-align-last: center;
    }

    .message-success-modal__card {
      margin-top: 20px;
      padding: 30px;
      font-size: 17px;
      background: rgba(103, 194, 58, 0.15);
      border-radius: 12px;
      text-indent: 2em;
    }
  }

  .message-success-modal__foot {
    display: flex;
    justify-content: center;
    justify-content: flex-end;
    margin-top: 80px;

    .message-success-modal__foot-btn {
      padding: 6px 20px;
      border: 1px solid var(--main-color-blue);
      border-radius: 8px;
      color: #333;
      cursor: pointer;
      font-size: 16px;
    }

    .message-success-modal__foot-btn-confirm {
      margin-left: 20px;
      background-color: var(--main-color-blue);
      color: #fff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/callMe/modules/success_modal.vue